import React, { useEffect, useRef } from "react";
import { components } from "../components";
import { theme } from "../constants";
import { useLocation, useNavigate } from "react-router-dom";
import { hooks } from "../hooks";
// import logo from "../../assets/nestfin/Nestfin_logo.png";
import logo from "../assets/nestfin/Nestfin_logo.png";
import html2canvas from "html2canvas";
import { svg } from "../assets/svg";
import { Shared } from "../assets/svg/Shared";

// Utility to convert number to words (simple example)
const numberToWords = (num: number) => {
  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];

  if (num < 10) return ones[num];
  else if (num >= 10 && num < 20) return teens[num - 10];
  else if (num < 100)
    return (
      tens[Math.floor(num / 10)] + (num % 10 !== 0 ? " " + ones[num % 10] : "")
    );
  else return num.toString(); // fallback
};

export const PaymentDetailsPage: React.FC = () => {
  const location = useLocation();
  const navigate = hooks.useNavigate();

  const screenshotRef = useRef<HTMLDivElement>(null);

  const paymentData = location.state as {
    amount: number;
    email: string;
    contact: string;
    name: string;
    booking_id: string;
    property_name: string;
    upi_id: string;
    upi_ref?: string;
    latitude?: string;
    longitude?: string;
    house_flat_block_no?: string;
    address?: string;
  };

  // const paymentData = (location.state as {
  //   amount: number;
  //   email: string;
  //   contact: string;
  //   name: string;
  //   booking_id: string;
  //   property_name: string;
  //   upi_id: string;
  //   upi_ref?: string;
  //   latitude?: string;
  //   longitude?: string;
  //   house_flat_block_no?: string;
  //   address?: string;
  // }) || {
  //   amount: 500,
  //   email: "test@example.com",
  //   contact: "+911234567890",
  //   name: "John Doe",
  //   booking_id: "BKG123456",
  //   property_name: "Test Property",
  //   upi_id: "nestfin@upi",
  //   upi_ref: "UPI1234567890",
  //   latitude: "latitude",
  //   longitude: "longitude",
  //   house_flat_block_no: "house_flat_block_no",
  //   address: "address",
  // };

  useEffect(() => {
    window.scrollTo(0, 0);

    if (!paymentData) {
      // If no data, redirect back
      navigate("/");
    }
  }, [paymentData, navigate]);

  const handleShareScreenshot = async () => {
    if (!screenshotRef.current) return;

    const canvas = await html2canvas(screenshotRef.current, {
      scale: 2,
      backgroundColor: "#fff",
    });

    canvas.toBlob(async (blob) => {
      if (!blob) return;

      const file = new File([blob], "payment_details.png", {
        type: "image/png",
      });

      if (
        navigator.share &&
        navigator.canShare &&
        navigator.canShare({ files: [file] })
      ) {
        try {
          await navigator.share({
            title: "Payment Receipt",
            text: "Here is my payment receipt from Nestfin",
            files: [file],
          });
        } catch (err) {
          console.error("Share cancelled or failed:", err);
        }
      } else {
        alert("Sharing not supported on this device. Please download instead.");
      }
    });
  };

  // Start Component
  const renderHeader = () => (
    // <components.Header
    //   title="Payment Details"
    //   goBack={true}
    //   style={{ backgroundColor: theme.colors.transparent }}
    // />
    <components.Header
      goBack={false}
      line={false}
      leftlogo={false}
      rightlogo={false}
      // search={true}
      filter={false}
      // logo={true}
      title={" "}
      // centerImageSrc={logo}
    />
  );

  const renderContent = () => {
    if (!paymentData) return null;

    // Function to open Google Maps directions
    const handleGetDirections = () => {
      const { latitude, longitude } = paymentData;
      console.log(">>>paymentData<<<", latitude, longitude);
      console.log(paymentData);
      if (latitude && longitude) {
        const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
        // window.open(mapsUrl, "_blank");
      } else {
        alert("Location data not available for this property.");
      }
    };

    return (
      <main
        style={{
          padding: "60px 16px 16px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        {/* Logo */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => navigate("/home")}
        >
          <img
            src={logo}
            alt="Logo"
            style={{ width: "150px", height: "auto" }}
          />
        </div>

        {/* Top Card: Payment Successful + Amount */}
        <div
          style={{
            backgroundColor: "#d4edda",
            color: "#000",
            borderRadius: "12px",
            padding: "24px",
            textAlign: "center",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <h1 style={{ margin: 0, fontSize: "24px", fontWeight: "600" }}>
            Payment Successful
          </h1>
          <div
            style={{
              fontSize: "40px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span>₹{paymentData.amount}</span>
            <img
              src={require("../assets/nestfin/checklist.png")}
              alt="Success"
              style={{ width: "60px", height: "60px" }}
            />
          </div>

          <div style={{ fontSize: "16px" }}>
            ({numberToWords(paymentData.amount)} Rupees)
          </div>
        </div>

        {/* Card 2: To Details */}
        <div
          style={{
            backgroundColor: "#e2e3e5",
            borderRadius: "12px",
            padding: "20px",
            // boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <div>
            To :&nbsp;
            <span style={{ fontWeight: "bold" }}>
              {" "}
              Nestfin Technologies Pvt Ltd{" "}
            </span>
          </div>
          {/* <div>
            UPI ID :<span>&nbsp; {paymentData.upi_id}</span>
          </div> */}
        </div>

        {/* Card 3: From Details */}
        <div
          style={{
            backgroundColor: "#e2e3e5",
            color: "#383d41",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <div>
            <span>From : </span>
            <span style={{ fontWeight: "bold" }}>{paymentData.name}</span>
          </div>
          <div>
            <strong>Transaction Id : </strong> {paymentData.upi_ref || "N/A"}
          </div>
          <div>
            <strong>Property Name : </strong> {paymentData.property_name || "-"}
          </div>

          {/* <div>
          <strong>Booking ID : </strong> {paymentData.booking_id || "N/A"}
        </div> */}

          <div style={{ lineHeight: "20px" }}>
            <strong style={{ fontWeight: "bold" }}> Address: </strong>{" "}
            {paymentData?.house_flat_block_no} {paymentData?.address}
          </div>

          {/* ✅ Get Directions Button */}
          <button
            onClick={handleGetDirections}
            style={{
              // display: "inline-block",
              // backgroundColor: "#070707ff",
              // border: "1px solid #fecc00",
              textAlign: "right",
              color: "#014d4e  ",
              padding: "5px 10px",
              borderRadius: "6px",
              textDecoration: "none",
              fontWeight: "bold",
              fontSize: 13,
            }}
          >
            📍 Get Directions
          </button>
        </div>
        {renderButton()}
      </main>
    );
  };

  const renderButton = () => {
    return (
      <div
        className="screenShortbtnContainer"
        style={{
          display: "flex",
          gap: "10px", // space between buttons
          alignItems: "stretch", // ensures same height
        }}
      >
        <button
          className="bottom-card-button buttonshared"
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            padding: "10px 20px",
          }}
          onClick={handleShareScreenshot}
        >
          <span>
            <Shared />
          </span>
          Share Now
        </button>

        <button
          className="bottom-card-button buttonshared"
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            padding: "10px 20px",
          }}
          onClick={() => navigate("/my-booking")}
        >
          My Booking
        </button>
      </div>
    );
  };

  return (
    <>
      {/* {renderHeader()} */}
      <div ref={screenshotRef}>{renderContent()}</div>
    </>
  );
};

// import React, { useEffect, useState } from "react";
// import { components } from "../components";
// import { theme } from "../constants";
// import { useLocation } from "react-router-dom";
// import { hooks } from "../hooks";

// export const PaymentDetailsPage: React.FC = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   const navigate = hooks.useNavigate();

//   const location = useLocation();

//   const renderHeader = () => (
//     <components.Header
//       title="Payment Detail"
//       goBack={true}
//       style={{ backgroundColor: theme.colors.transparent }}
//     />
//   );

//   const renderContent = () => (
//         <main style={{ paddingTop: "80px", paddingBottom: 0 }}>
//             <h1>Hello Dear</h1>
//         </main>
//   );

//   return (
//     <>
//       {renderHeader()}
//       {renderContent()}
//     </>
//   );
// };

// import React, { useEffect, useState } from "react";
// import { components } from "../components";
// import { theme } from "../constants";
// import { useLocation } from "react-router-dom";
// import { hooks } from "../hooks";
// import jsPDF from "jspdf";

// export const PaymentDetailsPage: React.FC = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [paymentStatus, setPaymentStatus] = useState("Paid");
//   const [roomData, setRoomData] = useState<any>(null);

//   const navigate = hooks.useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     // You can replace this with location.state or an API call
//     const fetchedData = {
//       property_id: "PR-B-2025-09-231",
//       property_name: "Home",
//       address: "123, Green Avenue, Bangalore, India",
//       contact_phone: "6200000000",
//       contact_email: "vikas@gmail.com",
//       security_deposit_months: "4 Months",
//       agreement_duration_months: "2 Months",
//       noticeperiod_months: "15-30 Days",
//       lockinperiod_months: "2 Months",
//       available_rooms: 4,
//       features: null,
//       unit_rent: 5000,
//       paidAmount:2000,
//       property_room_option_id: "RO-B-2025-09-513",
//       room_type_id: "1",
//       room_type_name: "Single basic",
//     };
//     setRoomData(fetchedData);
//   }, []);

//   // Handle PDF Download
// const handleDownloadPDF = () => {
//   if (!roomData) {
//     alert("Data is still loading...");
//     return;
//   }

//   const doc = new jsPDF();
//   let y = 10; // starting Y position

//   doc.setFontSize(16);
//   doc.text("Payment Details", 10, y);
//   y += 10;

//   doc.setFontSize(12);
//   doc.text(`Property Name: ${roomData.property_name}`, 10, y);
//   y += 10;
//   doc.text(`Room Type: ${roomData.room_type_name}`, 10, y);
//   y += 10;
//   doc.text(`Rent: ₹${roomData.unit_rent}`, 10, y);
//   y += 10;
//   doc.text(`Payment Status: ${paymentStatus}`, 10, y);
//   y += 10;

//   doc.text(`Contact Phone: ${roomData.contact_phone}`, 10, y);
//   y += 10;
//   doc.text(`Contact Email: ${roomData.contact_email || "N/A"}`, 10, y);
//   y += 10;
//   doc.text(`Agreement Duration: ${roomData.agreement_duration_months}`, 10, y);
//   y += 10;
//   doc.text(`Notice Period: ${roomData.noticeperiod_months}`, 10, y);
//   y += 10;
//   doc.text(`Lock-in Period: ${roomData.lockinperiod_months}`, 10, y);
//   y += 10;
//   doc.text(`Security Deposit: ${roomData.security_deposit_months}`, 10, y);
//   y += 10;

//   // Features
//   const featuresText = roomData.features && roomData.features.length > 0 ? roomData.features.join(", ") : "No amenities listed.";
//   doc.text(`Amenities: ${featuresText}`, 10, y);

//   doc.save("PaymentDetails.pdf");
// };

//   // Handle Print
//   const handlePrint = () => {
//     window.print();
//   };

//   const renderHeader = () => (
//     <components.Header
//       title="Payment Detail"
//       goBack={true}
//       style={{ backgroundColor: theme.colors.transparent }}
//     />
//   );

// const renderContent = () => {
//   if (!roomData)
//     return <p style={{ textAlign: "center", marginTop: "50px", color: "#555" }}>Loading...</p>;
//   // Helper to render detail row only if value exists
// const renderDetail = (label: string, value: any) => {
//   if (value === null || value === undefined || value === "") return null;

//   return (
//     <div
//       style={{
//         display: "flex",
//         flexWrap: "wrap", // allow wrapping for long text
//         padding: "8px 10px",
//         backgroundColor: "#f9f9f9",
//         marginBottom: "8px",
//         borderBottom: "1px solid #ff676740",
//         wordBreak: "break-word",
//       }}
//     >
//       <div
//         style={{
//           fontWeight: 500,
//           color: "#333",
//           fontSize: "14px",
//           marginRight: "10px",
//           minWidth: "120px", // reserve space for label
//         }}
//       >
//         {label}:
//       </div>
//       <div
//         style={{
//           color: "#555",
//           fontWeight: 500,
//           fontSize: "14px",
//           flex: 1, // take remaining space
//           textAlign: "left", // ensures long text wraps nicely
//         }}
//       >
//         {value}
//       </div>
//     </div>
//   );
// };

//   const roomTypeMap: { [key: number]: string } = {
//   1: "Single Sharing",
//   2: "Double Sharing",
//   3: "Triple Sharing",
// };
//   return (
//     <main style={{ paddingTop: "80px", paddingBottom: "40px", paddingInline: "20px", backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
//       <section
//         style={{
//           background: "#fff",
//           borderRadius: "10px",
//           boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
//           padding: "30px",
//           maxWidth: "900px",
//           margin: "0 auto",
//         }}
//       >
//         <h2 style={{ marginBottom: "20px", color: "#333", fontWeight:"600" }}>Property Details</h2>

//         <div>
//           {renderDetail("Name", roomData.property_name)}
//           {renderDetail("Address ", roomData.address)}
//           {renderDetail("Phone", roomData.contact_phone)}
//           {renderDetail("Email", roomData.contact_email || "N/A")}
//           {renderDetail("Agreement", `${roomData.agreement_duration_months}`)}
//           {renderDetail("Notice Period", `${roomData.noticeperiod_months}`)}
//           {renderDetail("Lock-in Period", `${roomData.lockinperiod_months}`)}
//           {renderDetail("Security Deposit", `${roomData.security_deposit_months}`)}
//         </div>

//         <h3 style={{ marginTop: "35px", marginBottom: "15px",fontWeight:"600" }}>Room Details</h3>
//         <div
//           style={{
//             // display: "grid",
//             // gridTemplateColumns: "1fr 1fr",
//             gap: "15px",
//           }}
//         >
//           {/* {renderDetail("Room Type ID", roomData.room_type_id)} */}
//           {renderDetail(
//   "Room Type",
//   roomTypeMap[roomData.room_type_id] || roomData.room_type_id
// )}
//           {renderDetail("Room Name", roomData.room_type_name)}
//         </div>

//         <h3 style={{ marginTop: "35px", marginBottom: "10px", fontWeight:"600" }}>Amenities</h3>
//         <p style={{ color: "#666", lineHeight: "1.6" }}>
//           {roomData.features && roomData.features.length > 0 ? roomData.features.join(", ") : "No amenities listed."}
//         </p>

//         <h3 style={{ marginTop: "35px", marginBottom: "15px", fontWeight:"600" }}>Price & Payment</h3>
//         {renderDetail("Payment Status", paymentStatus)}
//         {renderDetail("Monthly Rent", `₹${roomData.unit_rent}`)}
//         {renderDetail("Paid Amount", `₹${roomData.paidAmount}`)}

//         <div
//           style={{
//             display: "flex",
//             gap: "15px",
//             marginTop: "35px",
//             justifyContent: "flex-end",
//           }}
//         >
//           <button
//             onClick={handlePrint}
//             style={{
//               backgroundColor: "#555",
//               color: "#fff",
//               border: "none",
//               padding: "12px 20px",
//               borderRadius: "6px",
//               cursor: "pointer",
//               fontWeight: "500",
//             }}
//           >
//             Print
//           </button>
//           <button
//             onClick={handleDownloadPDF}
//             style={{
//               backgroundColor: "#007bff",
//               color: "#fff",
//               border: "none",
//               padding: "12px 20px",
//               borderRadius: "6px",
//               cursor: "pointer",
//               fontWeight: "500",
//             }}
//           >
//             Download PDF
//           </button>
//         </div>
//       </section>
//     </main>
//   );
// };

// const Detail = ({ label, value }: { label: string; value: any }) => (
//   <div
//     style={{
//       display: "flex",
//       flexDirection: "row",
//       justifyContent: "space-between",
//       alignItems: "center",
//       padding: "8px 10px",
//       borderRadius: "6px",
//       backgroundColor: "#f9f9f9",
//       // boxShadow: "inset 0 0 0 1px #e0e0e0",
//       wordBreak: "break-word",
//     }}
//   >
//     <div style={{ fontWeight: 600, color: "#333", fontSize:"14px" }}>{label}</div>
//     <div style={{ color: "#555", fontWeight: 500, textAlign: "right" }}>{value}</div>
//   </div>
// );

//   return (
//     <>
//       {renderHeader()}
//       {renderContent()}
//     </>
//   );
// };
